import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by the following machines: DP5, DS10-E, Gilbos Doubler,
// Heli (Pirn) KV2002, M50, M50 Wax, Ratera, Sahm 230E, SSM Duro, and Xeno

export default function WindingTensionRow({ windingTension = false, differentTitle }) {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = {target: {value: ""}};
   const minValue = windingTension ? "windingTensionMin" : "tensionMin";
   const maxValue = windingTension ? "windingTensionMax" : "tensionMax";

   return (
      <Row className="mb-2">
         <ColPrompt title={differentTitle ? differentTitle : "Winding Tension"} bold={true} description={"g"} />
         <ColValue size={2}>
            Min:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson?.[minValue] || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 1, 600, minValue)
                     : handleInputRangeChange(defaultOnChangeVal, 1, 600, minValue)
               }
            />
            {errorDivDefinitions?.[minValue] && <ErrorDiv>1-600 only</ErrorDiv>}
         </ColValue>
         <ColValue size={2}>
            Max:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson?.[maxValue] || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 1, 600, maxValue)
                     : handleInputRangeChange(defaultOnChangeVal, 1, 600, maxValue)
               }
            />
            {errorDivDefinitions?.[maxValue] && <ErrorDiv>1-600 only</ErrorDiv>}
         </ColValue>
      </Row>
   );
}
